import react from "react";

const Analysed = () => {
    return (
        <>
            <div className="analysed">
    <div className="bck">
        <div className="lazyload-wrapper ">
            <picture><img src="/assets/bg-analysed-IuXd-2Vw.png" width="1800" height="1467" alt="Trade"
                    draggable="false" loading="lazy" /></picture>
        </div>
    </div>
    <div className="wrapper">
        <div className="heading content">
            <div className="sub-title" data-reveal="bottom"
                style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}>
                AI-Powered</div>
            <h2 className="h1" data-reveal="bottom"
                style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}>
                <small>The first <strong>artificial intelligence</strong> protocol</small> that analyzes crypto gems
            </h2>
            <div className="intro" data-reveal="bottom"
                style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}>
                <p>Already <span>+4000 trades analyzed</span> on our protocol</p>
            </div>

            <div className="btn-group" data-reveal="bottom"
                style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}>
                <a className="btn" data-colors="primary" href="/analysis"><span className="btn-txt">Start Analyzing</span>
                    <div className="corner" data-colors="primary"><span className="corner-left"></span><span
                            className="corner-right"></span><span className="corner-top-bottom"></span></div>
                </a>
                <div className="point"></div>
            </div>
            <div className="point"></div>
        </div>
    </div>
</div>
        </>
    )
}

export default Analysed